import Check from "../Core/Check.js";
import Frozen from "../Core/Frozen.js";
import defined from "../Core/defined.js";
import destroyObject from "../Core/destroyObject.js";
import DeveloperError from "../Core/DeveloperError.js";
import ContextLimits from "./ContextLimits.js";
import RenderbufferFormat from "./RenderbufferFormat.js";

/**
 * @private
 */
function Renderbuffer(options) {
  var _options$format, _options$numSamples;
  options = options !== null && options !== void 0 ? options : Frozen.EMPTY_OBJECT;
  const context = options.context;
  const gl = context._gl;
  const maximumRenderbufferSize = ContextLimits.maximumRenderbufferSize;
  const format = (_options$format = options.format) !== null && _options$format !== void 0 ? _options$format : RenderbufferFormat.RGBA4;
  const width = defined(options.width) ? options.width : context.drawingBufferWidth;
  const height = defined(options.height) ? options.height : context.drawingBufferHeight;
  const numSamples = (_options$numSamples = options.numSamples) !== null && _options$numSamples !== void 0 ? _options$numSamples : 1;
  this._gl = gl;
  this._format = format;
  this._width = width;
  this._height = height;
  this._renderbuffer = this._gl.createRenderbuffer();
  gl.bindRenderbuffer(gl.RENDERBUFFER, this._renderbuffer);
  if (numSamples > 1) {
    gl.renderbufferStorageMultisample(gl.RENDERBUFFER, numSamples, format, width, height);
  } else {
    gl.renderbufferStorage(gl.RENDERBUFFER, format, width, height);
  }
  gl.bindRenderbuffer(gl.RENDERBUFFER, null);
}
Object.defineProperties(Renderbuffer.prototype, {
  format: {
    get: function () {
      return this._format;
    }
  },
  width: {
    get: function () {
      return this._width;
    }
  },
  height: {
    get: function () {
      return this._height;
    }
  }
});
Renderbuffer.prototype._getRenderbuffer = function () {
  return this._renderbuffer;
};
Renderbuffer.prototype.isDestroyed = function () {
  return false;
};
Renderbuffer.prototype.destroy = function () {
  this._gl.deleteRenderbuffer(this._renderbuffer);
  return destroyObject(this);
};
export default Renderbuffer;